function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
export default function DropdownIcon(props) {
  const output = /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1004.992 242.991c-12.658-12.669-27.663-18.998-45-18.998H64.005c-17.344 0-32.339 6.329-45.007 18.998C6.329 255.674 0 270.668 0 288.002c0 17.33 6.329 32.325 18.998 44.997l447.995 447.995c12.683 12.669 27.677 19.012 45.007 19.012s32.339-6.343 44.997-19.012l447.995-447.999c12.655-12.669 19.008-27.663 19.008-44.997 0-17.33-6.354-32.325-19.008-45.007z"
  }));
  return output;
}
